// 处理数据请求
import { postData } from "../lib/axios";

import { GET_APP_CONFIG_QUERY, SET_APP_CONFIG_MUTATION } from "../graphql";

const getTableDataBody = (tableId: string, workspaceId: string, blockId: string) => ({
  operationName: "getTableData",
  variables: {
    getTableDataInput: { workspaceId: workspaceId, tableId: tableId, blockId: blockId },
    viewQueryParams: { ids: [] },
    includeColumns: true,
    includeRows: true,
    includeViews: true,
  },
  query:
    "query getTableData($getTableDataInput: GetTableDataInput!, $viewQueryParams: PaginationQueryParams, $includeColumns: Boolean!, $includeRows: Boolean!, $rowIds: [String!], $includeViews: Boolean!) {\n  getTableData(getTableDataInput: $getTableDataInput) {\n    id\n    columns @include(if: $includeColumns) {\n      id\n      name\n      type\n      typeOptions\n      __typename\n    }\n    rows(ids: $rowIds) @include(if: $includeRows) {\n      id\n      cells\n      __typename\n    }\n    views(viewQueryParams: $viewQueryParams) @include(if: $includeViews) {\n      id\n      type\n      name\n      startDate\n      endDate\n      parentRow\n      stackedBy\n      form {\n        formInputs {\n          columnId\n          title\n          description\n          required\n          singleSelectType\n          specifiedOptions\n          __typename\n        }\n        name\n        coverUrl\n        logoUrl\n        description\n        redirectUrl\n        messageAfterSuccess\n        isBrandingRemoved\n        showSubmitAnotherResponse\n        showBlankForm\n        emailNotification\n        __typename\n      }\n      columns {\n        id\n        order\n        width\n        isHidden\n        isHiddenInKanban\n        __typename\n      }\n      rows {\n        id\n        order\n        __typename\n      }\n      controls\n      isAutoAddColumn\n      showColumnName\n      __typename\n    }\n    __typename\n  }\n}\n",
});

export const getWorkspaceDataBody = (workspaceId: string) => ({
  operationName: "GetWorkspaceQuery",
  variables: { workspaceIdInput: { id: workspaceId } },
  query:
    "query GetWorkspaceQuery($workspaceIdInput: WorkspaceIdInput!) {\n  workspace(workspaceIdInput: $workspaceIdInput) {\n    id\n    name\n   users {\n      id\n      individualGroupId\n      nickName\n      smallImage\n      role\n      color\n      __typename\n    }\n     nodes {\n      id\n      name\n      role\n      type\n      subNodes\n      viewMeta {\n        viewType\n        isAutoAddColumn\n        __typename\n      }\n     }\n     __typename\n  }\n}\n",
});

export const getTableData = (
  tableId: string,
  workspaceId: string,
  token: string,
  blockId: string,
  sessionId: string
) => {
  return postData(JSON.stringify(getTableDataBody(tableId, workspaceId, blockId)), token, sessionId);
};

export const getWorkspaceData = (workspaceId: string, token: string, sessionId: string) => {
  return postData(JSON.stringify(getWorkspaceDataBody(workspaceId)), token, sessionId);
};

export const getAppConfig = (blockId: string, token: string, sessionId: string) => {
  return postData(
    JSON.stringify({
      operationName: "GetAppConfigQuery",
      variables: {
        blockId,
      },
      query: GET_APP_CONFIG_QUERY,
    }),
    token,
    sessionId
  );
};

export const setAppConfig = (blockId: string, config: any, token: string, sessionId: string) => {
  return postData(
    JSON.stringify({
      operationName: "UpdateAppConfigQuery",
      variables: {
        updateAppConfigInput: {
          blockId,
          config: JSON.stringify(config),
        },
      },
      query: SET_APP_CONFIG_MUTATION,
    }),
    token,
    sessionId
  );
};